
/**
 * Modal de confirmación para la factura
 */
const ConfirmModal = ({ isOpen, onClose, onConfirm, factura }) => {
  if (!isOpen) return null;

  // Obtener el nombre del régimen fiscal y uso CFDI seleccionados
  const getRegimenLabel = (value) => {
    const regimenes = {
      '601': 'General de Ley Personas Morales',
      '603': 'Personas Morales con Fines no Lucrativos',
      '605': 'Sueldos y Salarios e Ingresos Asimilados a Salarios',
      '606': 'Arrendamiento',
      '608': 'Demás ingresos',
      '609': 'Consolidación',
      '610': 'Residentes en el Extranjero sin Establecimiento Permanente en México',
      '611': 'Ingresos por Dividendos (socios y accionistas)',
      '612': 'Personas Físicas con Actividades Empresariales y Profesionales',
      '614': 'Ingresos por intereses',
      '616': 'Sin obligaciones fiscales',
      '620': 'Sociedades Cooperativas de Producción que optan por diferir sus ingresos',
      '621': 'Régimen de Incorporación Fiscal',
      '625': 'Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas',
      '626': 'Régimen Simplificado de Confianza'
    };
    return regimenes[value] || value;
  };

  const getUsoCFDILabel = (value) => {
    const usos = {
      'G01': 'Adquisición de mercancías',
      'G02': 'Devoluciones, descuentos o bonificaciones',
      'G03': 'Gastos en general',
      'I01': 'Construcciones',
      'I02': 'Mobiliario y equipo de oficina por inversiones',
      'I03': 'Equipo de transporte',
      'I04': 'Equipo de cómputo y accesorios',
      'I05': 'Dados, troqueles, moldes, matrices y herramental',
      'I06': 'Comunicaciones telefónicas',
      'I07': 'Comunicaciones satelitales',
      'I08': 'Otra maquinaria y equipo',
      'D01': 'Honorarios médicos, dentales y gastos hospitalarios',
      'D02': 'Gastos médicos por incapacidad o discapacidad',
      'D03': 'Gastos funerales',
      'D04': 'Donativos',
      'D05': 'Intereses reales efectivamente pagados por créditos hipotecarios (casa habitación)',
      'D06': 'Aportaciones voluntarias al SAR',
      'D07': 'Primas por seguros de gastos médicos',
      'D08': 'Gastos de transportación escolar obligatoria',
      'D09': 'Depósitos en cuentas para el ahorro, primas que tengan como base planes de pensiones',
      'D10': 'Pagos por servicios educativos (colegiaturas)',
      'P01': 'Por definir'
    };
    return usos[value] || value;
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black/50">
      <div className="bg-white rounded-xl shadow-xl p-6 max-w-md w-full mx-4 md:mx-auto animate-fade-in max-h-[90vh] overflow-y-auto">
        <h3 className="text-xl font-bold text-primary mb-4">
          Confirma tus datos
        </h3>

        <div className="space-y-4 mb-6">
          <p className="text-sm text-gray-500">Por favor verifica que la siguiente información sea correcta:</p>

          <div className="space-y-3 bg-gray-50 p-4 rounded-lg">
            <div>
              <p className="text-xs text-gray-500">RFC</p>
              <p className="font-medium">{factura.rfc}</p>
            </div>

            <div>
              <p className="text-xs text-gray-500">Código de servicio</p>
              <p className="font-medium">{factura.serviceCode}</p>
            </div>

            {factura.descripcion_servicio && (
              <div>
                <p className="text-xs text-gray-500">Servicio</p>
                <p className="font-medium">{factura.descripcion_servicio}</p>
              </div>
            )}

            {factura.valor_unitario > 0 && (
              <div>
                <p className="text-xs text-gray-500">Valor del servicio</p>
                <p className="font-medium">${parseFloat(factura.valor_unitario).toFixed(2)}</p>
              </div>
            )}

            <div className="border-t border-gray-200 my-2 pt-2">
              <p className="text-xs font-medium text-gray-600">DATOS FISCALES</p>
            </div>

            <div>
              <p className="text-xs text-gray-500">Nombre o razón social</p>
              <p className="font-medium">{factura.nombreRazonSocial}</p>
            </div>

            <div>
              <p className="text-xs text-gray-500">Código postal</p>
              <p className="font-medium">{factura.codigoPostal}</p>
            </div>

            <div>
              <p className="text-xs text-gray-500">Régimen fiscal</p>
              <p className="font-medium">{factura.regimenFiscal} - {getRegimenLabel(factura.regimenFiscal)}</p>
            </div>

            <div>
              <p className="text-xs text-gray-500">Uso CFDI</p>
              <p className="font-medium">{factura.usoCfdi} - {getUsoCFDILabel(factura.usoCfdi)}</p>
            </div>

            <div>
              <p className="text-xs text-gray-500">Correo electrónico</p>
              <p className="font-medium">{factura.email}</p>
            </div>

            {factura.valor_unitario > 0 && (
              <div className="border-t border-gray-200 my-2 pt-2">
                <div className="flex justify-between">
                  <p className="text-sm font-medium">Subtotal:</p>
                  <p className="font-medium">${parseFloat(factura.valor_unitario).toFixed(2)}</p>
                </div>
                <div className="flex justify-between">
                  <p className="text-sm font-medium">IVA (16%):</p>
                  <p className="font-medium">${(parseFloat(factura.valor_unitario) * 0.16).toFixed(2)}</p>
                </div>
                <div className="flex justify-between font-bold">
                  <p className="text-sm">Total:</p>
                  <p>${(parseFloat(factura.valor_unitario) * 1.16).toFixed(2)}</p>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="flex space-x-4">
          <button
            onClick={onClose}
            className="flex-1 py-2 px-4 border border-gray-300 rounded-lg font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary/20 transition-all"
          >
            Cancelar
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 py-2 px-4 rounded-lg font-semibold bg-primary text-white hover:bg-primary/90 shadow-md hover:shadow-lg transition-all"
          >
            Confirmar
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
